import { Default_event } from '@/library/lib.js'
import EventsService from '@/services/Events.js'
import { tokenMethods } from '@/library/lib'

import moment from 'moment'


const state = {
  loading: false,
  loaded: false,
  error: null,
  current_event: new Default_event,
  events: {
    page: 1,
    events: []
  }
}


const actions = {
  init: function (state) {
    if (localStorage.getItem('fotty_token')) {
      tokenMethods.setToken(localStorage.getItem('fotty_token'), () => {
        EventsService.list(1).then(resp => {
          state.commit('SET_EVENTS', {page: 1, data: resp.data})
        })
      })
    }
  },

  async create_event(store, _event) {
    let event = {
      date_at: moment(_event.date_at).format('YYYY-MM-DD HH:mm:ss') || '',
      place: _event.place,
      title: _event.title,
      style_id: _event.style_id,
      tariff_id: _event.tariff_id,
      cover_id: _event.cover_id
    };
    await EventsService.create(event)
  },

  async edit_event(store, request = {
    event: new Default_event, cb: () => {
    }
  }) {
    let event = {
      date_at: moment(request.event.date_at).format('YYYY-MM-DD HH:mm:ss') || '',
      place: request.event.place,
      title: request.event.title,
      style_id: request.event.style_id,
      tariff_id: request.event.tariff_id,
      cover_id: request.event.cover_id,
      id: request.event.id || ''
    }

    return await EventsService.edit(
      event
    )
  },

  get_event: function (state, id) {
    EventsService.get(
      id
    ).then((event) => {
      state.commit('SET_CURRENT_EVENT', event.data)
    })
  },

  set_current_event: function (state, obj) {
    state.commit('SET_CURRENT_EVENT', obj)
  },

  delete: async ({state, commit}, eventId) => {
    if (state.loading) {
      return
    }
    commit('EVENT_REQUEST')
    try {
      await EventsService.delete(eventId)
      commit('EVENT_DELETE_SUCCESS', eventId)
    } catch (e) {
      commit('EVENT_ERROR', e)
    }
  },
}

const mutations = {
  EVENT_REQUEST: (state) => {
    state.loading = true
    state.loaded = false
  },
  EVENT_DELETE_SUCCESS: (state, eventId) => {
    state.loading = false
    state.loaded = true
    const {events} = state
    state.events.events = events.events.filter(event => event.id !== eventId)
  },
  SET_EVENTS: (state, obj) => {
    state.events.page = obj.page
    state.events.events = obj.data
  },
  CLEAR_CURRENT_EVENT: state => {
    state.current_event = new Default_event
    state.loaded = true
  },
  SET_CURRENT_EVENT: (state, obj) => {
    state.current_event = {...new Default_event, ...obj}
  },
  CHANGE_CURRENT: (state, obj) => {
    state.current_event = obj.data
  },
  EVENT_ERROR: (state) => {
    state.loading = false
  },

}
const getters = {
  get_current: state => {
    return {...state.current_event}
  },
  get_events: state => {
    return {...state.events}
  }
}


export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
